<template>
  <div class="add-change">
      <div class="head">
          <span class="title" v-if="changeState==false">新增地址</span>
          <span class="title" v-if="changeState==true">修改地址</span>
          <span class="disappear" @click="disappear">X</span>
      </div>
      <div class="line"></div>
      <div class="main">
          <div class="box">
              <p><span>*</span>收件人</p>
              <input type="text" v-model="forData.username">
          </div>
          <div class="box">
              <p><span>*</span>联系电话</p>
              <input type="text" v-model="forData.phone">
          </div>
          <div class="select">
              <p><span>*</span>选择地区</p>
              <div>
                <el-cascader v-model="district" :props="props" @change="handleChange" clearable></el-cascader>
              </div>
          </div>
          <div class="box">
              <p><span>*</span>详细地址</p>
              <input type="text" v-model="forData.address">
          </div>
          <div class="default">
              <input type="checkbox" v-model="statusFlag" @click="changeStatus()">
              <span>设置为默认地址</span>
          </div>
          <div class="btns">
              <button class="cancel" @click="disappear">取消</button>
              <button class="ok" @click="add" v-if="changeState==false">确定</button>
              <button v-if="changeState==true" @click="change(id)">保存</button>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  props:["flag",'id','changeState','itemData',"itemCityData"],
  data(){
      let _self = this;
      return{
          forData:{
            username:'',
            phone:'',
            address:'',
            status:0,
            province_code:'',
            city_code:'',
            district_code:'',
          },
          district: [],
          statusFlag: false,
          props: {
            lazy: true,
            lazyLoad: this.cascaderDistrict
          }
      }
  },
  methods: {
    cascaderDistrict(node,resolve){
        const { level } = node;
        const { data } = node;
        let parentCode = data ? data.value : "0";
        this.$api.address.district({
            code:parentCode
          }).then(res=>{
              const nodes = res.data
              .map(item => ({
                  value: item.adcode,
                  label: item.name,
                  leaf: level >= 2
              }));
              resolve(nodes);
          })
      },
      handleChange(value) {
        this.forData.province_code = value[0],
        this.forData.city_code = value[1],
        this.forData.district_code = value[2]
      },
      changeStatus(){
        this.statusFlag = !this.statusFlag
        if(this.statusFlag){
            this.forData.status = 1
        }else{
            this.forData.status = 0
        }
      },
      disappear(){
          this.$emit('flag',!this.flag)
      },
      add(){
           this.$api.address
            .addAddress({
             ...this.forData
            })
            .then((res) => {
                if(res.status == 1){
                   this.$emit('flag',!this.flag)
                   this.$emit('updateData')
                }else{
                    this.$message.closeAll()
                    this.$message.warning(res.msg);
                }
            });
      },
      change(id){
          this.$api.address
            .changeAddress({
              id:id,
             ...this.forData
            })
            .then((res) => {
                if(res.status == 1){
                   this.$emit('flag',!this.flag)
                   this.$emit('updateData')
                }else{
                   this.$emit('flag',!this.flag)
                }
            });
      }
  },
  created() {
      if(this.changeState==true){
          this.forData = this.itemData
          this.district = [this.forData.province_code,this.forData.city_code,this.forData.district_code]
      }else{
          this.forData={
            username:'',
            phone:'',
            address:'',
            status:0,
            province_code:'',
            city_code:'',
            district_code:'',
          }
      }
  },
}
</script>

<style lang="less" scoped>
.add-change{
    width: 620px;
    height: 446px;
    margin: auto;
    background: #ffffff;
    box-shadow: 0 0 26px 0 rgba(205,205,205,0.5);
    margin-top: 29px;
    .head{
        height:52px;
        width: 620px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .title{
            font-size: 14px;
            color: #333333;
            margin-left: 21px;
        }
        .disappear{
            margin-right: 24px;
            cursor: pointer;
        }
       
    }
    .line{
        width: 576px;
        height: 1px;
        border: 1px solid #f1f2f3;
        margin-left: 21px;
    }
    .main{
        .box{
            height: 30px;
            width: 620px;
            margin: 20px 55px 20px 46px;
            display: flex;
            p{
                width: 100px;
                height: 24px;
                font-size: 18px;
                color: #000;
                margin-right: 16px;
                text-align: right;
                span{
                    color:#f56c6c;
                    margin-right: 5px;
                    margin-bottom: 3px;
                }
            }
            input{
                width: 422px;
                height: 30px;
                background: #ffffff;
                border-radius: 3px;
                border: 1px solid #dddddd;
            }
        }
        .select{
            height: 30px;
            width: 620px;
            margin: 20px 55px 20px 46px;
            display: flex;
            p{
                width: 100px;
                height: 24px;
                font-size: 18px;
                color: #000;
                margin-right: 16px;
                text-align: right;
                span{
                    color:#f56c6c;
                    margin-right: 5px;
                    margin-bottom: 3px;
                }
            }
            div{
                cursor: pointer;
              /deep/.el-input__inner {
                    width: 422px;
                    height: 30px;
                    background: #ffffff;
                    border-radius: 3px;
                    border: 1px solid #dddddd;
                    }
            }
        }
    }
    .default{
        margin-left: 133px;
        margin-top: 18px;
        input{
            width: 12px;
            height: 12px;
            background: #ffffff;
            border: 1px solid #dddddd;
            margin-right: 7px;
        }
        span{
            width: 92px;
            height: 24px;
            font-size: 12px;
            text-align: left;
            color: #666666;
            line-height: 24px;
        }
    }
    .btns{ 
          display: flex;
           margin-left: 435px;
            margin-top:13px;
        button{
            width: 80px;
            height: 30px;
            border:0;
            &.ok{
             background: #ffbb00;
             color:#003871;
            }
            &.cancel{
              background: #fff;
             border: 1px solid #dddddd;
             margin-right: 7px;
            }
        }
    }
}
</style>